var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizzazione_tabella",
    "data-name": "icona visualizzazione tabella",
    transform: "translate(-626 -125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizzazione_tabella-2",
    "data-name": "icona visualizzazione tabella",
    transform: "translate(-1 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizzazione_tabella-3",
    "data-name": "icona visualizzazione tabella",
    transform: "translate(627 109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_341",
    "data-name": "Tracciato 341",
    d: "M16.125,17H1.875A1.85,1.85,0,0,1,0,15.182V2.818A1.85,1.85,0,0,1,1.875,1h14.25A1.85,1.85,0,0,1,18,2.818V15.182A1.85,1.85,0,0,1,16.125,17ZM1.875,1.727A1.11,1.11,0,0,0,.75,2.818V15.182a1.11,1.11,0,0,0,1.125,1.091h14.25a1.11,1.11,0,0,0,1.125-1.091V2.818a1.11,1.11,0,0,0-1.125-1.091Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_342",
    "data-name": "Tracciato 342",
    d: "M17.625,7.727H.375A.364.364,0,1,1,.375,7h17.25a.364.364,0,1,1,0,.727Z",
    transform: "translate(0 -1.636)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_343",
    "data-name": "Tracciato 343",
    d: "M17.625,12.727H.375a.364.364,0,1,1,0-.727h17.25a.364.364,0,1,1,0,.727Z",
    transform: "translate(0 -3)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_344",
    "data-name": "Tracciato 344",
    d: "M17.625,17.727H.375a.364.364,0,1,1,0-.727h17.25a.364.364,0,1,1,0,.727Z",
    transform: "translate(0 -4.364)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_345",
    "data-name": "Tracciato 345",
    d: "M6.375,18.636A.37.37,0,0,1,6,18.273V7.364a.375.375,0,0,1,.75,0V18.273A.37.37,0,0,1,6.375,18.636Z",
    transform: "translate(-1.5 -1.636)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_346",
    "data-name": "Tracciato 346",
    d: "M11.875,18.636a.37.37,0,0,1-.375-.364V7.364a.375.375,0,0,1,.75,0V18.273A.37.37,0,0,1,11.875,18.636Z",
    transform: "translate(-2.875 -1.636)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_347",
    "data-name": "Tracciato 347",
    d: "M17.375,18.636A.37.37,0,0,1,17,18.273V7.364a.375.375,0,0,1,.75,0V18.273A.37.37,0,0,1,17.375,18.636Z",
    transform: "translate(-4.25 -1.636)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_783",
    "data-name": "Rettangolo 783",
    transform: "translate(627 109)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 9,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_792",
    "data-name": "Rettangolo 792",
    transform: "translate(626 125)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTable);
export default __webpack_public_path__ + "static/media/view_table.a308c4896f16c9493edc0983d4afc0f8.svg";
export { ForwardRef as ReactComponent };